import _ from 'lodash';
import React, {Component} from 'react';
import { connect } from 'react-redux';
import {NEW_IMAGE_PATH} from 'Constants';
import  { Row, Col, Button }  from 'react-bootstrap';

class PublishListItem extends Component{
  constructor(props){
    super(props);

  }

  featurePageLink = () => {    
    this.props.history.push('/dashboard/features');
  }

  render(){
    var item=this.props.item;

    var desc=item.warningDesc;

    var iconUrl = `${NEW_IMAGE_PATH}publish/publish_exclamation.png`;
    var imageClickable = <img className='published-feature-icon' src={iconUrl} onClick={this.featurePageLink} style={{cursor:'pointer'}} />;

    if(item.count>0){
      iconUrl = `${NEW_IMAGE_PATH}publish/publish_tick.png`;
      imageClickable = <img className='published-feature-icon' src={iconUrl}/>;
      desc=item.desc;
    }

    return(
      <li>
        <Row>
          <Col md={2} style={{textAlign:'right'}}>
              {/* <img className='published-feature-icon' src={iconUrl} onClick={this.featurePageLink}/> */}
              {imageClickable}
          </Col>
          <Col md={10} className='published-feature-content'>
            <div className='published-feature-title'>{item.label}</div>
            <div className='published-feature-description'>{desc}</div>
          </Col>
        </Row>
      </li>
    )
  }
}
export default connect(null,null)(PublishListItem);
